import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, mobileIs } from "../../utils/siteUtils";
import { BackgroundImage, PrimaryButton } from "../../elements";
import "./style.scss";
const AboutUs = props => {
	const { rendering, fields, page } = props;
  const { title, description, pcImage, mobileImage, button } = fields;
  const [isActive, setIsActive] = useState(false);
  const [isDetailActive, setIsDetailActive] = useState(false);
  const rootNode = useRef()
  const isMobile = mobileIs()
  const isAR = page?.fields?.rtl?.value;

  const onScroll = () => {
  	let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
  	let nodeTop = rootNode.current.getBoundingClientRect().top;
  	if (isMobile) {
  		if (pageHeight - nodeTop > 100) {
	  		setIsActive(true)
	  	} else {
	  		setIsActive(false)
	  	}
	  	if (pageHeight - nodeTop > 400) {
	  		setIsDetailActive(true)
	  	} else {
	  		setIsDetailActive(false)
	  	}
  	} else {
  		if (pageHeight - nodeTop > 100) {
	  		setIsActive(true)
	  		setIsDetailActive(true)
	  	} else {
	  		setIsActive(false)
	  		setIsDetailActive(false)
	  	}
  	}
  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const rootClasses = classNames("c-about-us", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
    	<div className="c-about-us__space">
    		<div className={classNames("c-about-us__space__image", isActive ? 'active' : '')}>
    			<BackgroundImage {...pcImage} className="c-about-us__space__image__pc" />
    			<BackgroundImage {...mobileImage} className="c-about-us__space__image__mobile" />
    		</div>
    		<div className="c-about-us__space__detailinfo">
    			<div className="c-about-us__space__detailinfo__top"></div>
    			<div className={classNames("c-about-us__space__detail", isDetailActive ? 'active' : '', isAR ? 'rtl' : '')}>
	    			<RichText className={classNames("c-about-us__space__detail__title", isActive ? 'active' : '')} tag="div" field={title} />
	    			<RichText className={classNames("c-about-us__space__detail__description", isActive ? 'active' : '')} tag="div" field={description} />
	    			{button && <div className={classNames("c-about-us__space__detail__button", isActive ? 'active' : '')} >
	    				<PrimaryButton {...button?.fields} />
	    			</div>}
	    		</div>
	    		</div>
    	</div>
    </div>
  );
};

export default 	AboutUs;